import { Model, belongsTo } from 'miragejs';
import attr from 'ember-data/attr';

export default Model.extend({
  desksOnFloor: belongsTo('graphql/desks-on-floor'),
  meta: belongsTo('graphql/error-meta-data'),

  code: attr('number'),
  domain: attr('string'),
});
